import moment from "moment";
import { getCalendarPersonName } from "../../calendar/calendarDisplayHelpers";

const invoiceStaffName = (staff) => getCalendarPersonName(staff) || (typeof staff?.name === "string" ? staff.name.trim() : "");

const parseLocal = (value) => moment(value, ["YYYY-MM-DD HH:mm:ss", "YYYY-MM-DD H:mm:ss", "YYYY-MM-DDTHH:mm:ss"], true);

export const invoiceAppointmentMeta = (line = {}) => {
  const value = line.appointment || line;
  const start = parseLocal(line.start_datetime || value.start_datetime
    || (value.dateof && value.start_time ? `${value.dateof} ${value.start_time}` : null));
  const endValue = line.end_datetime || line.appointment?.end_datetime
    || (start.isValid() && value.end_time
      ? `${start.format("YYYY-MM-DD")} ${value.end_time}`
      : null);
  const end = parseLocal(endValue);
  if (!start.isValid() || !end.isValid()) return "";
  const staff = line.staff || line.appointment?.staff || {};
  const staffName = invoiceStaffName(staff);
  return `${staffName ? `With ${staffName} ` : ""}on ${start.format("DD MMMM YYYY")} at ${start.format("hh:mm A")} - ${end.isSame(start, "day") ? end.format("hh:mm A") : end.format("DD MMMM YYYY [at] hh:mm A")}`;
};

// Direct service sales may have staff without an appointment, or neither.
export const invoiceServiceMeta = (line = {}, invoiceDate) => {
  const appointment = invoiceAppointmentMeta(line);
  if (appointment) return appointment;
  const staffName = invoiceStaffName(line.staff || line.appointment?.staff);
  // A direct sale has no scheduled appointment. Label the authoritative invoice
  // date explicitly; never turn a purchase timestamp into a service time range.
  const date = moment(typeof invoiceDate === "string" ? invoiceDate.slice(0, 10) : null, "YYYY-MM-DD", true);
  return [staffName ? `With ${staffName}` : "", date.isValid() ? `Invoice date: ${date.format("DD MMMM YYYY")}` : ""].filter(Boolean).join(" · ");
};
